<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="supplierEids"
        @select="selectOne"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-upload
            :action="uploadUrl"
            :headers="uploadHeaders"
            :disabled="disabled"
            :on-error="handlerError"
            :on-exceed="onExceed"
            :on-progress="onProgress"
            :on-success="handleSuccess"
            :show-file-list="false"
            accept=".xlsx"
            style="display: inline-block;margin: 0 5px">
          <el-button :loading="importLoading" icon="el-icon-upload2" type="success">导入</el-button>
        </el-upload>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="序列号">
            <el-input v-model.trim="filter.serialNo" clearable/>
          </vm-search>
          <vm-search label="EID">
            <el-input v-model.trim="filter.eid" clearable/>
          </vm-search>
          <vm-search label="采购单号">
            <el-input v-model.trim="filter.buyOrderNo" clearable/>
          </vm-search>
          <vm-search label="录入姓名">
            <el-input v-model.trim="filter.creatorName" clearable/>
          </vm-search>
        </div>
      </template>
      <!--      <el-table-column type="selection" width="55"/>-->
      <el-table-column prop="serialNo" width="300" label="序列号"/>
      <el-table-column prop="eid" width="300" label="EID"/>
      <el-table-column prop="buyOrderNo" width="200" label="采购单号"/>
      <el-table-column prop="creatorName" label="录入人员"/>
    </vm-table>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import SupplierManageEdit from "@/views/information/SupplierManage/SupplierManageEdit";
  import SupplierManageMaterial from "@/views/information/SupplierManage/SupplierManageMaterial";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "SupplierEid",
    components: { VmTable, VmSearch},
    data() {
      return {
        idList: "",
        constant,
        ImportLoading: false,
        fileList: [],
        uploadUrl:window.config.basicServerUrl+"supplierEids/importFile",
        uploadHeaders: {"Authorization": loginUtil.getToken()},
        disabled:false,
        filter: {
          serialNo: "",
          eid: "",
          buyOrderNo: "",
          creatorName: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectOne(selection) {
        this.idList = selection;
        console.log(selection);
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },

      //导入
      onExceed() {
        this.$message.error("一次只能导入一张表，请刷新后再导入");
      },
      handleSuccess() {
        this.importLoading = false;
        this.disabled = false;
        this.$message.success("成功导入新的数据");
        this.getList(1);
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },

    },
  };
</script>

<style scoped>

</style>
